import { render, staticRenderFns } from "./newsCate.vue?vue&type=template&id=0b74d23b&scoped=true&"
import script from "./newsCate.vue?vue&type=script&lang=js&"
export * from "./newsCate.vue?vue&type=script&lang=js&"
import style0 from "./newsCate.vue?vue&type=style&index=0&id=0b74d23b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74d23b",
  null
  
)

export default component.exports